// removed by extract-text-webpack-plugin
module.exports = {"Button":"Button__Button__ajevi","Success":"Button__Success__1DMln","Danger":"Button__Danger__18hYt","Submit":"Button__Submit__37mVT","Danger2":"Button__Danger2__3ONKi"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Button/Button.css
// module id = 113
// module chunks = 2